/* eslint-disable @typescript-eslint/ban-ts-comment */
import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement } from 'lit/decorators.js';
import componentStyles from './idb-country-representation.css.lit';

/**
 * The Country Representation component.
 * @slot heading
 * @slot information
 * @slot total-contribution
 * @slot pie-chart-title
 * @slot pie-chart
 * @slot pie-chart-label
 */

@customElement('idb-country-representation')
export class IdbCountryRepresentation extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  render(): TemplateResult {
    return html`
      <div class="header">
        <slot name="heading"></slot>
      </div>
      <div class="content">
        <div class="description">
          <slot name="information"></slot>
          <slot name="total-contribution"></slot>
        </div>
        <div class="chart">
          <div class="pie-chart-title">
            <slot name="pie-chart-title"></slot>
          </div>
          <div class="pie-chart">
            <slot name="pie-chart"></slot>
          </div>
          <div class="pie-chart-label">
            <slot name="pie-chart-label"></slot>
          </div>
        </div>
      </div>
    `;
  }
}
